import axios from "@/axios";
import i18n from "@/i18n";

const state = {
  isLoading: false,
  languages: [],
  currentLanguage: localStorage.getItem("language") || "",
  currencies: [],
  currency: localStorage.getItem("currency"),
};

const getters = {
  currentLanguage: (state) => state.currentLanguage,
  currentLanguageName: ({ currentLanguage, languages }) => {
    if (currentLanguage) {
      const lang = languages.find((lang) => lang.id == currentLanguage);
      return lang?.name || "";
    }
    return "";
  },
  currentLanguageCode: ({ currentLanguage, languages }) => {
    if (currentLanguage) {
      const lang = languages.find((lang) => lang.id == currentLanguage);
      return lang?.code || "";
    }
    return "";
  },
  allLanguages: (state) => state.languages,
  allCurrencies: (state) => state.currencies,
  currency: (state) => state.currency,
  currencySymbol: ({ currencies, currency }) => {
    if (currency) {
      const curr = currencies.find(({ id }) => currency === id);
      return curr?.symbol || "";
    }
    return "";
  },
};

const actions = {
  fetchLanguages: async ({ commit, dispatch, state }) => {
    try {
      commit("setLoading", true);
      const { data: { status, payload } } =
          await axios.get(`languages`);
      if (status === "OK") {
        commit("setLanguages", payload);
        if (payload.length === 0) {
          commit("setCurrentLanguage", "");
          return;
        }
        // Найти default язык
        const defaultLanguage = payload.find((l) => l.default === 1);
        const isValid = payload.some((l) => l.id == state.currentLanguage);
        await dispatch("changeLocale", isValid ? state.currentLanguage : (defaultLanguage?.id || payload[0].id));
      }
    } catch (e) {
      console.error(e);
    } finally {
      commit("setLoading", false);
    }
  },

  changeLocale: async ({ commit, getters }, localeId) => {
    if (!localeId) return;
    commit("setCurrentLanguage", localeId);

    try {
      const { data } = await axios.get(`localizations`, {
        params: { lang_id: localeId }
      });

      let translations = {};
      if (Array.isArray(data) && data.length) {
        data.forEach(t => {
          const key = Object.keys(t)[0];
          translations[key] = t[key];
        });
      } else if (typeof data === "object") {
        translations = data;
      }

      const code = getters.currentLanguageCode;
      i18n.global.setLocaleMessage(code, translations);
      i18n.global.locale.value = code;
    } catch (e) {
      console.error(e);
    }
  },

  fetchCurrencies: async ({ commit }) => {
    try {
      commit("setLoading", true);
      const { data: { status, payload } } =
          await axios.get(`currencies`);
      if (status === "OK") {
        const currencies = payload.map(({ code: text, symbol }) => ({ id: text, text, symbol }));
        commit("setCurrencies", currencies);
        const saved = localStorage.getItem("currency");
        commit("setCurrency", saved || currencies[0].id);
      }
    } catch (e) {
      console.error(e);
    } finally {
      commit("setLoading", false);
    }
  },

  changeCurrency: ({ commit, state }, selectedCurrency) => {
    if (state.currencies.some((c) => c.id === selectedCurrency)) {
      commit("setCurrency", selectedCurrency);
    } else {
      console.warn("Selected currency is not available");
    }
  },
};

const mutations = {
  setLoading: (state, val) => { state.isLoading = val; },
  setLanguages: (state, langs) => { state.languages = langs; },
  setCurrencies: (state, currs) => { state.currencies = currs; },
  setCurrency: (state, curr) => {
    localStorage.setItem("currency", curr);
    state.currency = curr;
  },
  setCurrentLanguage: (state, lang) => {
    state.currentLanguage = lang;
    if (lang) localStorage.setItem("language", lang);
    else localStorage.removeItem("language");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
